import { Component, Input, OnInit } from '@angular/core';
import {
  WagtailPageContentElementInterface,
  WagtailShopBannerRendererInterface
} from "@gea-waldviertler-website/gea-models";
import { StylePropertyInterface } from "../two-lan/two-lan.component";

@Component({
    selector: 'wagtail-page-element-shop-banner',
    templateUrl: './shop-banner.component.html',
    styleUrls: ['./shop-banner.component.scss'],
    standalone: false
})
export class ShopBannerComponent implements OnInit {
  @Input() definition?: WagtailPageContentElementInterface<WagtailShopBannerRendererInterface>
  content?: WagtailShopBannerRendererInterface
  unicodeChar: string | undefined

  ngOnInit(): void {
    if (this.definition) {
      this.content = this.definition.value
    }
  }

  getLogo(): StylePropertyInterface {
    let styles: StylePropertyInterface = {}
    let logoPath: string = ""

    if (! this.content?.logo) {
      return styles
    }

    // get local logo path
    switch(this.content.logo) {
      case "waldviertler":
        logoPath = "/shop/assets/brands/logo-waldviertler.svg"
        styles['height'] = '40px'
        break
      case "gea":
        logoPath = "/shop/assets/brands/logo-gea.svg"
        styles['height'] = '60px'
        break
      case "brennstoff":
        logoPath = "/shop/assets/brands/logo-brennstoff.svg"
        styles['height'] = '60px'
        break
      default:
        logoPath = ""
        break
    }

    styles['-webkit-mask'] = 'url(' + logoPath + ') no-repeat center'
    styles['mask'] = 'url(' + logoPath + ') no-repeat center'

    styles['-webkit-mask-size'] = 'contain'
    styles['mask-size'] = 'contain'

    return styles
  }
}
